<template>
  <div class="custom-state-row">
    <div class="label-column truncate">
      {{ customState.label }}
    </div>
    <div valign="middle">
      <el-switch
        :value="customState.value"
        class="md-primary"
        on-text="True"
        on-color="#13ce66"
        off-text="False"
        off-color="#ff4949"
        :width="70"
        :disabled="readonly"
        @input="setValue"
      />
    </div>
    <div>
      <el-popover
        v-model="editPopoverVisible"
        placement="left"
        width="400"
        trigger="manual"
        :append-to-body="true"
      >
        <custom-state-editor
          :case-conf="caseConf"
          :custom-state="customState"
          :readonly="readonly"
          @apply="customState => applyEdit(customState)"
          @cancel="cancelEdit"
        />
        <el-button slot="reference" size="small" icon="more" @click="editPopoverVisible = true" />
      </el-popover>
    </div>
    <div>
      <el-button
        :disabled="readonly"
        icon="delete"
        size="small"
        @click="remove"
      />
    </div>
  </div>
</template>

<script>
import CustomStateEditor from './CustomStateEditor.vue';
import scopeMixins from '../utils/ScopeMixins';

export default {
  name: 'custom-state-row',
  components: {
    CustomStateEditor,
  },
  mixins: [ scopeMixins ],
  props: {
    caseConf: {
      type: Object,
      default: () => {}
    },
    customState: {
      type: Object,
      default: () => {}
    },
    readonly: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      editPopoverVisible: false,
    }
  },
  methods: {
    setValue(value) {
      this.customState.value = value;
      this.$emit('update', this.customState);
    },
    selectScope(scope) {
      this.customState.scope = scope;
      this.$emit('update', this.customState);
    },
    applyEdit(customState) {
      this.editPopoverVisible = false;
      this.$emit('apply', customState);
    },
    cancelEdit() {
      this.editPopoverVisible = false;
    },
    remove() {
      this.$emit('remove', this.customState);
    },
  }
}
</script>

<style scoped>
.custom-state-row {
  display: grid;
  grid-template-columns: 1fr auto auto auto;
  grid-gap: 4px;
  align-items: center;
  margin-left: 12px;
  margin-bottom: 8px;
  color: white;
}

.label-column {
  cursor: pointer;
  padding-right: 8px;
}

.truncate {
  display: inline-block;
  max-width: 330px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>